const toSnakeCase = (str: any) => {
    if (str !== undefined || str !== null) {
      return str
        .replace(/[\w]([A-Z])/g, function (match:any) {
          return match[0] + "_" + match[1].toLowerCase();
        })
        .replace(/\s+/g, "_")
        .toLowerCase();
    } else {
      return str;
    }
    // if (str !== undefined || str !== null) {
    //   return str.toLowerCase().replace(/\s+/g, "_");
    // } else {
    //   return str;
    // }
  };

  const leadingZeros = (num: number, digits: number) => {
    const str = num.toString();
    const newNum = str.padStart(digits, "0");
    return newNum;
  };

  const formatedDate = (dateInput: Date, format?: string | any) => {
    // default DD/MM/YYYY
    if (dateInput) {
      const date = new Date(dateInput);
      const day = leadingZeros(date.getDate(), 2);
      const month = leadingZeros(date.getMonth() + 1, 2);
      const year = leadingZeros(date.getFullYear(), 4);
      let foramtedDate = `${day}/${month}/${year}`;
  
      if (format === "YYYY-MM-DD") {
        foramtedDate = `${year}-${month}-${day}`;
      }
    
      return foramtedDate;
    } else if (dateInput === "") {
      return "";
    } else {
      return "-/-/-";
    }
  };

  const CalculateAge = (dateInput: Date) => {
    const date = new Date(dateInput);
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    const m = today.getMonth() - date.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < date.getDate())) {
      age--;
    }
    return age;
  }


  function formatDateMMDDYYYY(date: Date | string): string {
  const d = new Date(date);
  const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth is 0-based
  const day = String(d.getUTCDate()).padStart(2, '0');
  const year = d.getUTCFullYear();
  return `${month}/${day}/${year}`;
}
  export {toSnakeCase,formatedDate, CalculateAge,formatDateMMDDYYYY}